module.exports = __webpack_public_path__ + "static/carousel-slide-02-72b7beab3ed328b79d26b0e920b7338d.png";